import { createSvgComponent } from "../../icon/createSvgComponent";
import Padlock from "@core/__generated__/icon/figma/padlock.svg";
export default createSvgComponent(Padlock);